module.exports = {"users":["98010672302","98010675874","98010620220","98010677083","98010676950","160991191","80002951894","50001038764","98010676936","98015704688","98010672711","50000966065","98010677889","98015710015","98010676903","98015712541","98015638877","98010677889"]}


//////////////////
// WEBPACK FOOTER
// ./src/_override/static/json/users-go.json
// module id = 936
// module chunks = 33